import { UsersResponse } from "@/models/UsersResponse.js";
import UsersService from "../UserService.js";
import { PaginationStore } from "@/store/pagination-store.js";
import errorManager from "@/modules/errors/error-services/error-manager";

class UsersStore extends PaginationStore {
  data() {
    return {
      sizes: [2, 5, 10, 20, 50, 100],
      call: async (pagination) => {
        const param = {
          page: pagination.currentPage,
          size: pagination.elements > 0 ? pagination.elements : 10,
          sortBy: 'id',
        };

        return this.getUsers(param);
      },
    };
  }
  async getUsers(param) {
    try {
      const response = await UsersService.getUsers(param);
      console.log(response);
      let result_1 = new UsersResponse({});
      if (response.data) {
        result_1 = new UsersResponse(response.data);
      }
      return await Promise.resolve(result_1);
    } catch (error) {
      return await errorManager.manage(
        error,
        errorManager.caseNotFound(() =>
          Promise.resolve(new UsersResponse({}))
        ),
        errorManager.defaultCase(() => {
          errorManager.pushPageError(error);
          return Promise.reject(error);
        })
      )
    }
  }
  async updateUserRole(user) {
    try {
      await UsersService.updateUserRole(user.id, user)
      await this.loadPage(
        usersStore.paginationParams.currentPage,
        await this.getState().call
      )
    } catch (error) {
      return await errorManager.manage(error, errorManager.deafaultReject(error));
    }
  }
}
export const usersStore = new UsersStore("USERS");
